export type BoundingBoxString = string;

export const BASE_ZOOM_LEVEL = 15;
export const LAT_LNG_PRECISION = 7;

export interface LatLngZoom {
	lat: number;
	lng: number;
	zoom: number;
}

export const BoundingString = {
	toString(center: google.maps.LatLngLiteral, zoom: number): BoundingBoxString {
		var currentZoom = zoom || BASE_ZOOM_LEVEL;
		if (center == null) {
			return ``;
		}

		return `@${center.lat.toFixed(LAT_LNG_PRECISION)},${center.lng.toFixed(LAT_LNG_PRECISION)},${currentZoom.toFixed(0)}z`;
	},

	fromString(str: BoundingBoxString): LatLngZoom | null {
		if (typeof str !== 'string') {
			return null;
		}

		if (str.length < 2 || str.charAt(0) !== '@' || str.charAt(str.length - 1) !== 'z') {
			return null;
		}

		var chunks = str
			.substr(1, str.length - 2)
			.split(',')
			.map((val) => parseFloat(val));
		var [lat, lng, zoom] = chunks;

		if (isNaN(lat) || isNaN(lng) || isNaN(zoom)) {
			return null;
		}

		if (lat === 0 || lng === 0 || zoom === 0) {
			return null;
		}

		return { lat, lng, zoom };
	},
};
